import {
  WalletProviderPriority,
  getDefaultClient,
  getWalletProviderRegistry,
  hasExtension,
  registerExtension,
} from '@dynamic-labs-sdk/client/core';

import { registerSuiNetworkProviderBuilder } from '../../registerSuiNetworkProviderBuilder';
import { createWalletProviderForWaasSui } from '../utils/createWalletProviderForWaasSui';

export const WAAS_SUI_EXTENSION_KEY = 'waasSui';

/**
 * Adds the Dynamic WaaS (Wallet as a Service) Sui extension to the Dynamic client.
 *
 * This extension enables embedded wallet functionality for Sui blockchain,
 * allowing users to have wallets managed by Dynamic's infrastructure.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 */
export const addWaasSuiExtension = (client = getDefaultClient()): void => {
  if (hasExtension({ extensionKey: WAAS_SUI_EXTENSION_KEY }, client)) {
    return;
  }

  registerExtension({ extensionKey: WAAS_SUI_EXTENSION_KEY }, client);
  registerSuiNetworkProviderBuilder(client);

  const walletProviderRegistry = getWalletProviderRegistry(client);

  const walletProvider = createWalletProviderForWaasSui(client);

  walletProviderRegistry.register({
    priority: WalletProviderPriority.WALLET_SDK,
    walletProvider,
  });
};
